import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {Contract} from "../../../shared/interface/contract";
import {ContractService} from "../../../shared/services/contract.service";

export interface ChangeInvoiceNumberDialogData {
  contractObject: Contract;
}
@Component({
  selector: 'app-contract-invoice-number-edit',
  templateUrl: './contract-invoice-number-edit.component.html',
  styleUrls: ['./contract-invoice-number-edit.component.scss']
})
export class ContractInvoiceNumberEditComponent implements OnInit, OnDestroy {

  changeInvoiceNumberForm: FormGroup;
  contractObject: Contract;
  processingRequest = false;
  invoiceNumberControl: FormControl;
  enableSaveButton = false;
  enableEditButton = false;



  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ContractInvoiceNumberEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeInvoiceNumberDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private contractService: ContractService,
    private snack: MatSnackBar,
  ) {
    this.contractObject = data.contractObject;
    this.changeInvoiceNumberForm = fb.group({
      invoiceNumber: this.invoiceNumberControl = fb.control('', [Validators.required]),
    });
    const invoiceNumber = this.contractObject.invoiceNumber;
    this.invoiceNumberControl.setValue(invoiceNumber);
    this.invoiceNumberControl.disable();
  }

  ngOnInit(): void {
    this.changeInvoiceNumberForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeInvoiceNumberForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;

    const invoiceUuid = this.contractObject.uuid;

    this.contractService.changeInvoiceNumber(this.changeInvoiceNumberForm.value, invoiceUuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano numer faktury', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji numeru faktury wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }
  edit(): void{
    this.enableEditButton = !this.enableEditButton;
    if (this.enableEditButton){
      this.invoiceNumberControl.enable();
     } else {
      this.invoiceNumberControl.disable();
    }
  }
}
